import React from 'react';

/* External */
import { useTranslation } from 'react-i18next';

/* Material UI */
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';

/* Project */
import ButtonWithLoader from 'commons/containers/ButtonWithLoader';

function DeleteModal(props) {
  const { toggleForm, isOpen, submit, buttonId, loading, error } = props;
  const { t } = useTranslation();

  return (
    <Dialog fullWidth onClose={toggleForm} aria-labelledby="simple-dialog-title" open={isOpen}>
      <DialogTitle>{t('Confirm deletion')}</DialogTitle>
      <DialogContent>
        <Typography>{t('Confirm delete message')}</Typography>
        {error && (
          <Typography style={{ marginTop: 10 }} color="error">
            {error}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={toggleForm} color="primary">
          {t('Cancel')}
        </Button>
        <ButtonWithLoader onClick={submit} autoFocus buttonId={buttonId} loading={loading}>
          {t('Confirm')}
        </ButtonWithLoader>
      </DialogActions>
    </Dialog>
  );
}

export default DeleteModal;
